import {Label} from "@progress/kendo-react-labels";
import LoadOverlay from "../../Components/SharedComponents/LoadOverlay";
import {Button, ButtonGroup} from "@progress/kendo-react-buttons";
import {Tooltip} from "@progress/kendo-react-tooltip";
import {Input} from "@progress/kendo-react-inputs";
import {TreeList} from "@progress/kendo-react-treelist";
import angleLeftRightThemeColorIcon
    from "../../Components/Segmentation/temporaryresources/images/arrow-left-right-theme-color.svg";
import React, {useEffect, useState} from "react";
import {extendDataItem, mapTree} from "@progress/kendo-react-common";
import {semcastAxios, showErrorToastMessage} from "../../../Utils/Common";
import {IDENTITY_PIPELINE_APPEND_TREE} from "../../../api/constants";

//This function needs to be outside of the main component to prevent rerender
const RowRender = (properties) => {
    const {row, props, onDrop, onDragStart} = properties;
    const additionalProps = {
        onDragStart: (e) => onDragStart(e, props),
        onDragOver: (e) => {
            e.preventDefault();
        },
        // onDrop: (e) => onDrop(e, props),
        draggable: true,
    };
    return React.cloneElement(
        row,
        {...row.props, ...additionalProps},
        row.props.children
    );
};
export default function EditAppendTree({
                                        availableAttributes,
                                        selectedAttributes,
                                        onChange = () => {},
                                        setSelectedAttributesCount = () => {},
                                        setFinalAvailableAttributes = () => {},
                                        setFinalSelectedAttributes = () => {},
                                        exportType = "FILE_EXCHANGE",
                                    }) {
    // const {availableAttributes, selectedAttributes, setSelectedAttributes} = props;
    const [generateReportCheckbox, setGenerateReportCheckbox] = useState(false);

    const [labelValue, setLabelValue] = React.useState('');
    const [checked, setChecked] = React.useState(false);
    const [originalTree, setOriginalTree] = useState({});
    const [loadOverlay, setLoadOverlay] = useState(true);
    const [treeList2Count, setTreeList2Count] = React.useState([]);
    const [tempSearchValues1, setTempSearchValues1] = useState([]);
    const [tempSearchValues2, setTempSearchValues2] = useState([]);
    const [expand1, setExpand1] = useState(true);
    const [expand2, setExpand2] = useState(true);
    const [tabList, setTablist] = useState([]);
    const [canonicalTree, setCanonicalTree] = useState(null);
    // const [defaultObj, setDefaultObj] = useState({});
    const [selectedTab, setSelectedTab] = React.useState("");
    const subItemsField = 'items';
    const expandField = 'expanded';
    const dataItemKey = 'treeId';
    const [treeState, setTreeState] = React.useState({
        data1: [],
        data2: [],
        expanded1: [],
        expanded2: [],
        dataState1: {
            sort: [],
            filter: [],
        },
        dataState2: {
            sort: [],
            filter: [],
        },
    });

    const columns = [
        {
            field: "text",
            title: " ",
            width: "250px",
            expandable: true,
        },
    ];

    const removeUnavailableDigitalIdentifierFields = (tree) => {
        if (!tree || typeof tree !== "object") {
            return tree;
        }
        const clone = JSON.parse(JSON.stringify(tree));
        const hiddenDigitalIdentifierFields = [
            "Client ID",
            "Signal Matched Semcasting ID",
            "UTM Codes",
        ];

        const prune = (node, parentKey = null) => {
            if (Array.isArray(node)) {
                return node
                    .map((item) => prune(item, parentKey))
                    .filter((item) => {
                        if (item === undefined) {
                            return false;
                        }
                        if (typeof item === "string") {
                            return !(
                                parentKey === "Digital Identifiers" &&
                                hiddenDigitalIdentifierFields.includes(item)
                            );
                        }
                        if (Array.isArray(item)) {
                            return item.length > 0;
                        }
                        if (item && typeof item === "object") {
                            return Object.keys(item).length > 0;
                        }
                        return true;
                    });
            } else if (node && typeof node === "object") {
                const result = {};
                Object.keys(node).forEach((key) => {
                    if (
                        parentKey === "Digital Identifiers" &&
                        hiddenDigitalIdentifierFields.includes(key)
                    ) {
                        return;
                    }
                    const processed = prune(node[key], key);
                    if (processed === undefined) {
                        return;
                    }
                    if (Array.isArray(processed) && processed.length === 0) {
                        return;
                    }
                    if (processed && typeof processed === "object" && !Array.isArray(processed) && Object.keys(processed).length === 0) {
                        return;
                    }
                    result[key] = processed;
                });
                return result;
            } else if (typeof node === "string") {
                if (
                    parentKey === "Digital Identifiers" &&
                    hiddenDigitalIdentifierFields.includes(node)
                ) {
                    return undefined;
                }
                return node;
            }
            return node;
        };

        return prune(clone);
    };

    const parseTreePayload = (payload) => {
        if (!payload) return {};
        if (typeof payload === "string") {
            try {
                return JSON.parse(payload || "{}");
            } catch (err) {
                console.error("Failed to parse tree payload", err);
                return {};
            }
        }
        return JSON.parse(JSON.stringify(payload));
    };

    const unwrapSegmentWrapper = (payload) => {
        const parsed = parseTreePayload(payload);
        const keys = Object.keys(parsed || {});
        if (keys.length === 1) {
            const key = keys[0];
            if (key === "Household Segment" || key === "Business Segment") {
                const inner = parsed[key];
                if (inner && typeof inner === "object") {
                    return JSON.parse(JSON.stringify(inner));
                }
            }
        }
        return parsed;
    };

    const isValueEmpty = (value) => {
        if (value === null || value === undefined) return true;
        if (Array.isArray(value)) return value.length === 0;
        if (typeof value === "object") return Object.keys(value).length === 0;
        return false;
    };

    const reconcileTrees = (baseNode, selectedNode) => {
        if (Array.isArray(baseNode)) {
            const baseValues = [...baseNode];
            const allowedSelection = Array.isArray(selectedNode)
                ? selectedNode.filter((value) => baseValues.includes(value))
                : [];
            const remainingBase = baseValues.filter((value) => !allowedSelection.includes(value));
            return {base: remainingBase, selection: allowedSelection};
        } else if (baseNode && typeof baseNode === "object") {
            const baseResult = {};
            const selectionResult = {};
            Object.keys(baseNode).forEach((key) => {
                const childBase = baseNode[key];
                const childSelection = selectedNode ? selectedNode[key] : undefined;
                const {base, selection} = reconcileTrees(childBase, childSelection);
                if (!isValueEmpty(base)) {
                    baseResult[key] = base;
                }
                if (!isValueEmpty(selection)) {
                    selectionResult[key] = selection;
                }
            });
            return {base: baseResult, selection: selectionResult};
        } else {
            if (selectedNode && selectedNode === baseNode) {
                return {base: null, selection: selectedNode};
            }
            return {base: baseNode, selection: null};
        }
    };

    useEffect(() => {
        let mounted = true;
        const fetchTree = async () => {
            try {
                setLoadOverlay(true);
                const params = exportType ? {pipelineType: exportType} : {};
                const response = await semcastAxios.get(IDENTITY_PIPELINE_APPEND_TREE, {
                    withCredentials: true,
                    params,
                });
                let payload = response?.data;
                if (typeof payload === "string") {
                    payload = JSON.parse(payload || "{}");
                }
                payload = unwrapSegmentWrapper(payload);
                payload = removeUnavailableDigitalIdentifierFields(payload);
                if (mounted) {
                    setCanonicalTree(payload);
                }
            } catch (error) {
                console.error("Failed to load append tree for identity pipeline", error);
                showErrorToastMessage("Unable to load append tree for this export type.", 10);
                if (mounted) {
                    setCanonicalTree(null);
                    setLoadOverlay(false);
                }
            }
        };
        fetchTree();
        return () => {
            mounted = false;
        };
    }, [exportType]);


    useEffect(() => {
        if ((tabList.length > 0 && treeState.data1.length > 0) || treeState.data2.length > 0) {
            setLoadOverlay(false);
        }
    }, [tabList, treeState]);


    useEffect(() => {
        //Select the first tab by default
        setSelectedTab(tabList[0])
    }, [tabList]);

    function reorderObject(target, reference) {
        function reorderKeys(obj, refObj) {
            let ordered = {};
            // Add keys from reference in the specified order
            Object.keys(refObj).forEach(key => {
                if (obj.hasOwnProperty(key)) {
                    if (typeof refObj[key] === 'object' && !Array.isArray(refObj[key])) {
                        ordered[key] = reorderKeys(obj[key], refObj[key]); // Recursively reorder sub-objects
                    } else if (Array.isArray(refObj[key]) && Array.isArray(obj[key])) {
                        ordered[key] = obj[key].sort((a, b) => refObj[key].indexOf(a) - refObj[key].indexOf(b));
                    } else {
                        ordered[key] = obj[key];
                    }
                }
            });

            // Append any remaining keys from obj that were not in refObj
            Object.keys(obj).forEach(key => {
                if (!ordered.hasOwnProperty(key)) {
                    ordered[key] = obj[key];
                }
            });

            return ordered;
        }

        return reorderKeys(target, reference);
    }


    function removeEmptyValues(obj) {
        if (typeof obj !== "object" || obj === null) return obj;

        let newObj = Array.isArray(obj) ? [] : {};

        for (let key in obj) {
            let value = removeEmptyValues(obj[key]);

            // Keep only non-empty values
            if (Array.isArray(value) && value.length === 0) continue;
            if (typeof value === "object" && Object.keys(value).length === 0) continue;

            newObj[key] = value;
        }

        return newObj;
    }

    function transformToNestedArray(obj) {
        let idCounter = 1; // Initialize the ID counter

        function createObject(key, value) {
            return {
                treeId: idCounter++, // Assign unique ID and increment the counter
                text: key,
                value: value,
                items: []
            };
        }

        function recursiveTransform(obj) {
            return Object.entries(obj).map(([key, value]) => {
                if (Array.isArray(value)) {
                    // Handle array values by creating an item for each array element
                    return {
                        treeId: idCounter++,
                        text: key,
                        value: key,
                        items: value.map(item => createObject(item, item))
                    };
                } else if (typeof value === 'object' && value !== null) {
                    // Handle nested objects by processing them recursively
                    return {
                        treeId: idCounter++,
                        text: key,
                        value: key,
                        items: recursiveTransform(value)
                    };
                } else {
                    // Handle string or direct mapping values
                    return createObject(key, value);
                }
            });
        }

        return recursiveTransform(obj);
    }

    function removeEmptyNodes(obj) {
        const cleaned = {};

        for (const key in obj) {
            const value = obj[key];

            if (value && typeof value === "object" && !Array.isArray(value)) {
                const nested = removeEmptyNodes(value);
                if (Object.keys(nested).length > 0) {
                    cleaned[key] = nested;
                }
            } else if (Array.isArray(value)) {
                if (value.length > 0) {
                    cleaned[key] = value;
                }
            } else if (value !== "" && value != null) {
                cleaned[key] = value;
            }
        }

        return cleaned;
    }

    const hydrateTreeState = (baseSource, selectionSource) => {
        const baseClone = unwrapSegmentWrapper(baseSource);
        const sanitizedBase = removeUnavailableDigitalIdentifierFields(baseClone);
        setSelectedTab("");
        if (!sanitizedBase || Object.keys(sanitizedBase).length === 0) {
            showErrorToastMessage("Error: Tree object is null or undefined.", 10);
            setLoadOverlay(false);
            return;
        }
        const selectionClone = parseTreePayload(selectionSource);
        const sanitizedSelection = removeUnavailableDigitalIdentifierFields(selectionClone || {});
        const leftJsonObj = removeEmptyNodes(sanitizedBase);
        const normalizedSelection = removeEmptyNodes(sanitizedSelection || {});

        const {base: filteredBaseRaw, selection: filteredSelectionRaw} = reconcileTrees(leftJsonObj, normalizedSelection);
        const filteredBase = removeEmptyValues(filteredBaseRaw || {});
        const filteredSelection = removeEmptyValues(filteredSelectionRaw || {});

        setFinalAvailableAttributes(filteredBase);
        setOriginalTree(filteredBase);

        const leftTreeFull = transformToNestedArray(filteredBase);
        const rightTreeFull = transformToNestedArray(filteredSelection);
        const leftTree = leftTreeFull.filter(obj => obj.items && obj.items.length !== 0);
        const rightTree = rightTreeFull.filter(obj => obj.items && obj.items.length !== 0);

        setTreeState(prev => ({
            ...prev,
            data1: leftTree,
            data2: rightTree,
            expanded1: leftTree.map((i) => i.treeId),
            expanded2: rightTree.map((i) => i.treeId),
            dataState1: {
                sort: [],
                filter: [],
            },
            dataState2: {
                sort: [],
                filter: [],
            },
        }));
        setTempSearchValues1(leftTreeFull);
        setTempSearchValues2(rightTreeFull);
        const tempList = [];
        leftTree.forEach(item => {
            tempList.push(item.text);
        });
        setTablist(tempList);
        if (!leftTree.length && !rightTree.length) {
            setLoadOverlay(false);
        }
    };

    useEffect(() => {
        const baseSource = canonicalTree && Object.keys(canonicalTree || {}).length
            ? canonicalTree
            : availableAttributes;
        if (!baseSource || Object.keys(parseTreePayload(baseSource)).length === 0) {
            return;
        }
        hydrateTreeState(baseSource, selectedAttributes || {});
    }, [canonicalTree, availableAttributes, selectedAttributes]);


    const handleTabOnClick = (e, val) => {
        e.preventDefault();
        setTreeState(
            {
                ...treeState,
                expanded1: treeState.data1.map((i) => i.treeId)
            })
        if (selectedTab === val) {
            setSelectedTab("")
        } else {
            switch (val) {
                case selectedTab !== "":
                    setSelectedTab("");
                    break;
                case val:
                    setSelectedTab(val);
                    break;
                default:
                // code block
            }
        }
    }

    function contains(text, term) {
        return text.toLowerCase().indexOf(term.toLowerCase()) >= 0;
    }

    function search(items, term) {
        return items.reduce((acc, item) => {
            if (contains(item.text, term)) {
                acc.push(item);
            } else if (item.items && item.items.length > 0) {
                let newItems = search(item.items, term);
                if (newItems && newItems.length > 0) {
                    acc.push({
                        text: item.text,
                        items: newItems,
                        treeId: item.treeId,
                        value: item.value /*, expanded: item.expanded*/
                    });
                }
            }
            return acc;
        }, []);
    }

    const handleSearch1 = () => {
        let allExpanded = [];
        let value = document.querySelector('.dragndrop-search-box1').value;
        let newData = search(tempSearchValues1, value);
        //Expand all search result if search value is not empty
        if (value.length !== 0) {
            mapTree(newData.slice(), subItemsField, (item) => {
                allExpanded.push(item[dataItemKey]);
            });
            setTreeState({
                ...treeState,
                data1: newData,
                expanded1: allExpanded
            })
        } else {
            setTreeState({
                ...treeState,
                data1: newData,
                expanded1: newData.map((i) => i.treeId)
            })
        }


    }
    const handleSearch2 = () => {
        let allExpanded = [];
        let value = document.querySelector('.dragndrop-search-box2').value;
        let newData = search(tempSearchValues2, value);
        //Expand all search result if search value is not empty
        if (value.length !== 0) {
            mapTree(newData.slice(), subItemsField, (item) => {
                allExpanded.push(item[dataItemKey]);
            });
            setTreeState({
                ...treeState,
                data2: newData,
                expanded2: allExpanded
            })
        } else {
            setTreeState({
                ...treeState,
                data2: newData,
                expanded2: newData.map((i) => i.treeId)
            })
        }
    }

    function countObjectsWithoutItems(arr) {
        let count = 0;

        arr.forEach(obj => {
            // Check if the object has no 'items' property or if 'items' is an empty array
            if (!obj.items || obj.items.length === 0) {
                count++;
            } else {
                // Recursively check for nested items
                count += countObjectsWithoutItems(obj.items);
            }
        });

        return count;
    }

    useEffect(() => {
        const result = countObjectsWithoutItems(treeState.data2)
        setTreeList2Count(result);
    }, [treeState]);


    function sortTreeOrder(data) {
        return data.sort((a, b) => {
            const indexA = tabList.indexOf(a.text);
            const indexB = tabList.indexOf(b.text);

            // If text is not found in B, it will return -1. You can adjust sorting for such cases if needed.
            return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
        });
    }

    const processData1 = () => {
        let {data1, dataState1} = treeState;
        const sortedData = sortTreeOrder(data1);
        if (selectedTab !== "") {
            data1 = sortedData.filter(item => item.text === selectedTab);
        }
        return addExpandField1(data1);
    };
    const processData2 = () => {
        let {data2, dataState2} = treeState;
        // const sortedData = sortTreeOrder(data2);
        return addExpandField2(data2);
    };
    const addExpandField1 = (dataTree) => {
        const expanded = treeState.expanded1;
        return mapTree(dataTree, subItemsField, (item) =>
            extendDataItem(item, subItemsField, {
                [expandField]: expanded.includes(item.treeId)
            })
        );
    };
    const addExpandField2 = (dataTree) => {
        const expanded = treeState.expanded2;
        return mapTree(dataTree, subItemsField, (item) =>
            extendDataItem(item, subItemsField, {
                [expandField]: expanded.includes(item.treeId)
            })
        );
    };
    const onTreeList1ExpandChange = (e) => {
        setTreeState({
            ...treeState,
            expanded1: e.value
                ? treeState.expanded1.filter((id) => id !== e.dataItem.treeId)
                : [...treeState.expanded1, e.dataItem.treeId],
        });
    };
    const onTreeList2ExpandChange = (e) => {
        setTreeState({
            ...treeState,
            expanded2: e.value
                ? treeState.expanded2.filter((id) => id !== e.dataItem.treeId)
                : [...treeState.expanded2, e.dataItem.treeId],
        });
    };
    const handleTreeList1StateChange = (event) => {
        setTreeState({
            ...treeState,
            dataState1: event.dataState,
        });
    };
    const handleTreeList2StateChange = (event) => {
        setTreeState({
            ...treeState,
            dataState2: event.dataState,
        });
    };

    const rowForTreeList1 = (row, props) => {
        return (
            <RowRender
                props={props}
                row={row}
                // onDrop={handleOnDropFirst}
                onDragStart={handleDragStartFirst}
            />
        );
    };
    const rowForTreeList2 = (row, props) => {
        return (
            <RowRender
                props={props}
                row={row}
                // onDrop={handleOnDropSecond}
                onDragStart={handleDragStartSecond}
            />
        );
    };
    const handleDragStartFirst = (e, props) => {
        const {dataItem, level} = props;
        setTreeState({
            ...treeState,
            dragFrom: 'first',
            dragged: {dataItem, level},
        });
    };

    const handleDragStartSecond = (e, props) => {
        const {dataItem, level} = props;
        setTreeState({
            ...treeState,
            dragFrom: 'second',
            dragged: {dataItem, level},
        });
    };

    //Process data for adding items to tree
    function addToParent(A, B, input) {
        // Helper function to find the parent node by its value
        function findParent(array, value) {
            for (const node of array) {
                if (node.items && node.items.some(item => item.value === value)) {
                    return node; // Parent found
                }
                if (node.items) {
                    const parent = findParent(node.items, value);
                    if (parent) return parent;
                }
            }
            return null;
        }

        // Helper function to find or create the parent chain in B
        function findOrCreateParentChainInB(B, parentChain) {
            let currentLevel = B;

            for (const parent of parentChain) {
                let existingNode = currentLevel.find(node => node.value === parent.value);

                if (!existingNode) {
                    // Create a new node in B for this part of the chain
                    existingNode = {...parent, items: []};
                    currentLevel.push(existingNode);
                }

                currentLevel = existingNode.items;
            }

            return currentLevel; // Return the items array where the input should be added
        }

        // Helper function to sort an array alphabetically by the 'text' property
        function sortArray(array) {
            return array.sort((a, b) => a.text.localeCompare(b.text));
        }

        // Recursive function to sort objects and nested arrays
        function sortObjectAndArrays(node) {
            if (Array.isArray(node)) {
                node.forEach(sortObjectAndArrays); // Recursively sort each item in the array
                sortArray(node); // Sort the array itself
            } else if (node && typeof node === "object") {
                if (node.items) {
                    sortObjectAndArrays(node.items); // Recursively sort items in the object
                }
            }
        }

        // Helper function to merge items
        function mergeItems(existingNode, inputNode) {
            if (inputNode.items && inputNode.items.length > 0) {
                inputNode.items.forEach(inputItem => {
                    const existingItem = existingNode.items.find(item => item.value === inputItem.value);
                    if (existingItem) {
                        // Recursively merge items
                        mergeItems(existingItem, inputItem);
                    } else {
                        // Add the new item
                        existingNode.items.push({...inputItem});
                    }
                });
            }
        }

        // Step 1: Find the parent chain for the input object in A
        const parentChain = [];
        let currentParent = findParent(A, input.value);

        while (currentParent) {
            parentChain.unshift(currentParent); // Build the chain from root to the immediate parent
            currentParent = findParent(A, currentParent.value);
        }

        // Step 2: Ensure the parent chain exists in B
        const parentItemsInB = findOrCreateParentChainInB(B, parentChain);

        // Step 3: Add or merge the input object into B
        const existingNode = parentItemsInB.find(node => node.value === input.value);

        if (existingNode) {
            // Merge items if input has additional items
            mergeItems(existingNode, input);
        } else {
            // Add input as a new node
            parentItemsInB.push({...input});
        }

        // Step 4: Sort B and all nested arrays
        sortObjectAndArrays(B);

        return B;
    }

    function removeObjectAndParentByValue(A, input) {
        // Deep copy the array A to avoid modifying the original array
        const copyA = JSON.parse(JSON.stringify(A));

        // Helper function to remove an object from its parent's 'items' array
        function removeObjectFromParent(array, value) {
            for (let i = 0; i < array.length; i++) {
                const node = array[i];
                // If we find the node with the matching value
                if (node.value === value) {
                    // If the node has siblings (i.e., more than one item in the parent array)
                    if (array.length > 1) {
                        // Remove the node from the parent's 'items' array
                        array.splice(i, 1);
                        return true;
                    } else {
                        // If the node is the only one in the array, remove it
                        array.splice(i, 1);
                        return true;
                    }
                }
                // If the node has children (items), search in those
                if (node.items && node.items.length > 0) {
                    const result = removeObjectFromParent(node.items, value);
                    if (result) {
                        // If we found and removed the object, return true to stop further search
                        if (node.items.length === 0) {
                            // If the node's items are empty after removal, remove the parent node
                            array.splice(i, 1);
                        }
                        return true;
                    }
                }
            }
            return false; // Return false if no match was found in this array level
        }

        // Call the helper function on the copy of A
        removeObjectFromParent(copyA, input.value);

        return copyA; // Return the modified copy of array A
    }

    function mergeInputIntoA(A, input) {
        // Helper function to merge `items` recursively
        const mergeItems = (originalItems, newItems) => {
            const merged = [...originalItems];

            newItems.forEach(newItem => {
                const match = merged.find(item => item.value === newItem.value);

                if (match) {
                    // If the item exists, merge its `items` recursively
                    match.items = mergeItems(match.items || [], newItem.items || []);
                } else {
                    // If the item does not exist, add it to the merged array
                    merged.push(newItem);
                }
            });

            return merged;
        };

        // Iterate through the input array
        input.forEach(inputNode => {
            // Find the matching node in array A
            const match = A.find(node => node.value === inputNode.value);

            if (match) {
                // Merge the `items` arrays for the matched node
                match.items = mergeItems(match.items || [], inputNode.items || []);
            } else {
                // If no match, add the input node to array A
                A.push(inputNode);
            }
        });

        return A;
    }

    function treeListItemClickUtil(tempSegList1, tempSegList2, dataItem, onClickList1) {


        //On TreeList1 Item Click
        if (onClickList1) {
            tempSegList2 = addToParent(treeState.data1, treeState.data2, dataItem);
            tempSegList1 = removeObjectAndParentByValue(treeState.data1, dataItem);

            //On TreeList2 Item Click
        } else {

            tempSegList1 = addToParent(treeState.data2, treeState.data1, dataItem);
            tempSegList2 = removeObjectAndParentByValue(treeState.data2, dataItem);
        }
        // console.log("tempSegList1", tempSegList1);
        // console.log("tempSegList2", tempSegList2)
        return {list1: tempSegList1, list2: tempSegList2}
    }

    const onTreeListItemClick1 = (e) => {
        let tempSegList2 = treeState.data2;
        let tempSegList1 = treeState.data1;
        const selectedItem = e.dataItem;

        if (e.level.length === 1) {
            if (!tempSegList2.find(item => item.value === selectedItem.value)) {
                tempSegList2.push(selectedItem);
            } else {
                tempSegList2.map(item => {
                    if (item.value === selectedItem.value) {
                        item.items = mergeInputIntoA(item.items || [], selectedItem.items || []);
                    }
                });
            }
            tempSegList1 = treeState.data1.filter(item => item.value !== selectedItem.value);
        } else {
            const values = treeListItemClickUtil(tempSegList1, tempSegList2, selectedItem, true);
            tempSegList1 = values.list1;
            tempSegList2 = values.list2;
        }

        let allExpandedList2 = [];
        mapTree(treeState.data2.slice(), subItemsField, (item) => {
            allExpandedList2.push(item[dataItemKey]);
        });
        setTreeState(
            {
                ...treeState,
                data1: tempSegList1,
                data2: tempSegList2,
                expanded2: allExpandedList2
            });

        setTempSearchValues1(tempSegList1);
        setTempSearchValues2(tempSegList2);
    }
    const onTreeListItemClick2 = (e) => {
        let tempSegList2 = treeState.data2;
        let tempSegList1 = treeState.data1;
        const currentItem = e.dataItem;

        if (e.level.length === 1) {
            if (!tempSegList1.find(item => item.value === currentItem.value)) {
                tempSegList1.push(currentItem);
            } else {
                tempSegList1.map(item => {
                    if (item.value === currentItem.value) {
                        item.items = mergeInputIntoA(item.items || [], currentItem.items || []);
                    }
                });
            }
            tempSegList2 = treeState.data2.filter(item => item.value !== currentItem.value);
        } else {
            const values = treeListItemClickUtil(tempSegList1, tempSegList2, currentItem, false);
            tempSegList1 = values.list1;
            tempSegList2 = values.list2;
        }

        let allExpandedList2 = [];
        mapTree(treeState.data2.slice(), subItemsField, (item) => {
            allExpandedList2.push(item[dataItemKey]);
        });
        setTreeState(
            {
                ...treeState,
                data1: tempSegList1,
                data2: tempSegList2,
                expanded2: allExpandedList2
            });

        setTempSearchValues1(tempSegList1);
        setTempSearchValues2(tempSegList2);
    }
    const handleDiv1 = () => {
        if (treeState.dragFrom === 'second') {
            let tempSegList2 = treeState.data2;
            let tempSegList1 = treeState.data1;
            const {dragged} = treeState;
            const {dataItem, level} = dragged;

            if (level.length === 1) {
                if (!tempSegList1.find(item => item.value === dataItem.value)) {
                    tempSegList1.push(dataItem);
                } else {
                    tempSegList1.map(item => {
                        if (item.value === dataItem.value) {
                            item.items = mergeInputIntoA(item.items || [], dataItem.items || []);
                        }
                    });
                }
                tempSegList2 = treeState.data2.filter(item => item.value !== dataItem.value);
            } else if (level.length !== 1) {
                const values = treeListItemClickUtil(tempSegList1, tempSegList2, dataItem, false);
                tempSegList1 = values.list1;
                tempSegList2 = values.list2;
            }


            setTreeState(
                {
                    ...treeState,
                    data1: tempSegList1,
                    data2: tempSegList2
                });

            setTempSearchValues1(tempSegList1);
            setTempSearchValues2(tempSegList2);

        }
    };
    const handleDiv2 = () => {

        if (treeState.dragFrom === 'first') {
            const {dragged} = treeState;
            const {dataItem, level} = dragged;
            let tempSegList2 = treeState.data2;
            let tempSegList1 = treeState.data1;


            if (level.length === 1) {
                if (!tempSegList2.find(item => item.value === dataItem.value)) {
                    tempSegList2.push(dataItem);
                } else {
                    tempSegList2.map(item => {
                        if (item.value === dataItem.value) {
                            item.items.push(...dataItem.items);
                        }
                    })
                }
                tempSegList1 = treeState.data1.filter(item => item.value !== dataItem.value);
            } else {
                const values = treeListItemClickUtil(tempSegList1, tempSegList2, dataItem, true);
                tempSegList1 = values.list1;
                tempSegList2 = values.list2;
            }
            let allExpandedList2 = [];
            mapTree(treeState.data2.slice(), subItemsField, (item) => {
                allExpandedList2.push(item[dataItemKey]);
            });

            setTreeState(
                {
                    ...treeState,
                    data1: tempSegList1,
                    data2: tempSegList2,
                    expanded2: allExpandedList2
                });

            setTempSearchValues1(tempSegList1);
            setTempSearchValues2(tempSegList2);

        }
    };
    const expandAll = (e, tree) => {
        e.preventDefault();
        //Expand all search result
        let allExpanded = [];
        if (tree === '1') {
            mapTree(treeState.data1.slice(), subItemsField, (item) => {
                allExpanded.push(item[dataItemKey]);
            });
            setExpand1(false);
            setTreeState({
                ...treeState,
                expanded1: allExpanded
            })
        } else {
            mapTree(treeState.data2.slice(), subItemsField, (item) => {
                allExpanded.push(item[dataItemKey]);
            });
            setExpand2(false);
            setTreeState({
                ...treeState,
                expanded2: allExpanded
            })
        }
    };
    const collapseAll = (e, tree) => {
        e.preventDefault();
        //Collapse all search result
        if (tree === '1') {
            setExpand1(true)
            setTreeState({
                ...treeState,
                expanded1: []
            })
        } else {
            setExpand2(true)
            setTreeState({
                ...treeState,
                expanded2: []
            })
        }
    }

    function transformTreeToObject(treeList) {
        const result = {};

        function traverse(items) {
            let obj = {};
            for (const item of items) {
                if (item.items && item.items.length > 0) {
                    const childResult = traverse(item.items);

                    // Convert to array if all child values are simple strings
                    const allSimpleValues = Object.values(childResult).every(v => typeof v === "string");
                    obj[item.text] = allSimpleValues ? Object.values(childResult) : childResult;
                } else {
                    obj[item.text] = item.value;
                }
            }
            return obj;
        }

        for (const category of treeList) {
            result[category.text] = traverse(category.items || []);
        }

        return result;
    }

    const loggedInFromToolbox = sessionStorage.getItem("isToolboxLogged");
    const segmentNamingData = loggedInFromToolbox ? [{
        text: 'Category',
        value: 'CATEGORY',
        id: 1
    }, {
        text: 'Website',
        value: 'URL',
        id: 2
    }, {
        text: 'No Segments',
        value: 'NONE',
        id: 3
    }] : [{
        text: 'Website',
        value: 'URL',
        id: 2
    }, {
        text: 'No Segments',
        value: 'NONE',
        id: 3
    }];

    function transformToNestedObject(arr) {
        const result = {};
        let temp = findKeysWithNonEmptyArray(originalTree);


        // console.log(pushKeyValuesToArray(originalTree['Retail Store Visits']))
        arr.forEach(item => {
            if (item.items && item.items.length > 0) {
                if (temp.includes(item.text)) {
                    // If item.text is in temp, directly assign item.items array as value
                    result[item.text] = item.items.map(subItem => subItem.value);
                } else {
                    // Otherwise, recursively transform the nested items
                    result[item.text] = transformToNestedObject(item.items);
                }
            } else {
                // If no nested items, map the value directly
                result[item.text] = item.value;
            }
        });

        return result;
    }

    function findKeysWithNonEmptyArray(obj) {
        const result = [];

        function traverse(currentObj, currentKey) {
            if (Array.isArray(currentObj) && currentObj.length > 0) {
                result.push(currentKey);
            } else if (typeof currentObj === 'object' && currentObj !== null) {
                for (const key in currentObj) {
                    traverse(currentObj[key], key);
                }
            }
        }

        traverse(obj, null);
        return result;
    }

    useEffect(() => {

        onChange(reorderObject(transformTreeToObject(treeState.data2), originalTree));
    }, [treeState]);

    useEffect(() => {
        setSelectedAttributesCount(treeList2Count);
    }, [treeList2Count]);
    return (
        <div className={"ip idx-dialog-tree"}>
            <LoadOverlay active={loadOverlay} width={'100%'} height={'100px'}>
                <div className="data-append-inner-wrapper">
                    <Label className={"required-asterisk"}>Append the following to the output file: </Label>
                    <div className={"tree-table-wrapper mt-1 mb-3"}>
                        <div className={"tab-button-group-wrapper"}>
                            <div className="tab-button-group">
                                <ButtonGroup>
                                    {tabList.map((item, index) => {
                                        return (
                                            item !== "" ?
                                                <Button
                                                    className={`${selectedTab === item && "btn-primary"}`}
                                                    togglable={true} selected={selectedTab === item}
                                                    onClick={(e) => handleTabOnClick(e, item)}>
                                                    {item}
                                                </Button> :
                                                ""
                                        )
                                    })}
                                </ButtonGroup>
                                <Tooltip
                                    position="right"
                                    anchorElement="target"
                                    tooltipStyle={{
                                        width: "15rem",
                                        borderRadius: "0.25rem",
                                    }}
                                >
                                    <i className="fa fa-question-circle-o tooltip-question-icon"
                                       aria-hidden="true"
                                       title={"Select any tab to see the filtered list. Deselect the selected tab to see the full list."}></i>
                                </Tooltip>
                            </div>
                        </div>
                        <div className={"tree-outter-wrapper"}>
                            <div className={"left-tree-wrapper"}
                                 style={{width: "-webkit-fill-available"}}>
                                <div className={"tree-tool-bar"}>
                                    <Input className={"dragndrop-search-box1"} onChange={handleSearch1}
                                           placeholder={'Search...'}/>
                                    <Button
                                        onClick={e => expand1 ? expandAll(e, '1') : collapseAll(e, '1')}
                                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                        style={{marginLeft: '10px'}}
                                    >
                                        {expand1 ? "Expand all" : "Collapse all"}
                                    </Button>
                                </div>
                                <div
                                    className={"drag-panel1"}
                                    onDrop={handleDiv1}
                                    onDragOver={(e) => {
                                        e.preventDefault()
                                    }}
                                >
                                    <TreeList
                                        {...treeState.dataState1}
                                        style={{
                                            height: "50vh",
                                            overflow: "auto",
                                            marginTop: "20px",
                                        }}
                                        expandField={expandField}
                                        subItemsField={subItemsField}
                                        data={processData1()}
                                        columns={columns}
                                        onDataStateChange={handleTreeList1StateChange}
                                        onExpandChange={onTreeList1ExpandChange}
                                        onRowClick={onTreeListItemClick1}
                                        rowRender={rowForTreeList1}
                                    />
                                </div>
                            </div>
                            <img alt="" src={angleLeftRightThemeColorIcon}
                                 style={{
                                     width: "50px",
                                     alignSelf: "center",
                                     paddingLeft: '5px',
                                     paddingRight: '5px'
                                 }}
                            />
                            <div className={"right-tree-wrapper"}
                                 style={{width: "-webkit-fill-available"}}>

                                <div className={"selected-count"}>Selected Attributes
                                    ({treeList2Count})
                                </div>
                                <div className={"tree-tool-bar"}>
                                    <Input className={"dragndrop-search-box2"} onChange={handleSearch2}
                                           placeholder={'Search...'}/>
                                    <Button
                                        onClick={e => expand2 ? expandAll(e, '2') : collapseAll(e, '2')}
                                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                        style={{marginLeft: '10px'}}
                                    >
                                        {expand2 ? "Expand all" : "Collapse all"}
                                    </Button>
                                </div>
                                <div
                                    className={"drag-panel2"}
                                    onDrop={handleDiv2}
                                    onDragOver={(e) => {
                                        e.preventDefault()
                                    }}
                                >
                                    <TreeList
                                        style={{
                                            height: "50vh",
                                            overflow: "auto",
                                            marginTop: "20px",
                                        }}
                                        expandField={expandField}
                                        subItemsField={subItemsField}
                                        data={processData2()}
                                        columns={columns}
                                        onDataStateChange={handleTreeList2StateChange}
                                        onExpandChange={onTreeList2ExpandChange}
                                        onRowClick={onTreeListItemClick2}
                                        rowRender={rowForTreeList2}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </LoadOverlay>

        </div>
    )
}
